<template>
  <section id="section1" class="section" style="position: relative">
    <div class="offer-and-privacy-policy mt-app-header " style="">
      <Recipe2></Recipe2>
    </div>
  </section>
  <section id="section2" class="section" style="position: relative">
    <div class="catalog" style="margin: 2%!important;">
      <CatalogMainScreen title = "Товары, упомянутые в статье"></CatalogMainScreen>
    </div>
  </section>
  <section id="section3" class="section" style="position: relative">
    <div class="client-footer">
      <ClientFooter></ClientFooter>
    </div>
  </section>
</template>

<style scoped lang="scss">
@media (max-width: 600px) {
  .mt-app-header {
    margin: 15% 2% 2% !important;
  }
}

@media (max-width: 1600px) and (min-width: 991px) {
  .mt-app-header {
    margin: 8% 2% 8% !important;
  }
}
@media (max-width: 990px) and (min-width: 601px) {
  .mt-app-header {
    margin: 8% 2% 2% !important;
  }
}

@media (min-width: 1601px) {
  .mt-app-header {
    margin: 5% 2% 2% !important;
  }
}
</style>
<script>

import Recipe2 from "@/components/recipes/Recipe2Screen.vue"
import ClientFooter from "@/components/footers/ClientFooter.vue";
import CatalogMainScreen from "@/components/mainScreen/CatalogMainScreen.vue";
export default {
  name: 'recipesView',
  components: {
    Recipe2,
    CatalogMainScreen,
    ClientFooter
  }
}
</script>
